// extracted by mini-css-extract-plugin
module.exports = {"card":"OurServiceCard_card__1bL0x"};